exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".carousel.component{height:540px;position:relative}.carousel.component img{position:absolute;opacity:0;transition:1s}.carousel.component img.active{opacity:1}.carousel.component .indicators{width:100%;margin:0;line-height:8px;text-align:center;position:absolute;bottom:20px}.carousel.component .indicators li{display:inline-block;width:10px;height:10px;background:#333;border-radius:5px;opacity:.5}.carousel.component .indicators li+li{margin-left:10px}.carousel.component .indicators li.active{opacity:1}@media screen and (max-width:850px){.carousel.component{height:472px}#google-map{width:500px}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/widgets/carousel.less
 ** module id = 157
 ** module chunks = 0
 **/